import React from 'react';
import {Form, Edit, Suggestions, Flex, List} from 'components';
import {useNamedSelector} from 'helpers';

export function BeliefsInquiry2() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'beliefs-inquiry-2' })}>
      <List tiny-gutter>
        <List.Title>What are the most positive beliefs you have about yourself?</List.Title>
        <Flex even stack>
          <Edit name="1" Suggestions={Suggestions.PositiveBeliefs} />
          <Edit name="2" Suggestions={Suggestions.PositiveBeliefs} />
          <Edit name="3" Suggestions={Suggestions.PositiveBeliefs} />
        </Flex>
        <List.Title>How do these positive beliefs support you in your life?</List.Title>
        <Flex even stack>
          <Edit name="4" />
          <Edit name="5" />
          <Edit name="6" />
        </Flex>
        <List.Title>Which beliefs give you the most strength?</List.Title>
        <Flex even stack>
          <Edit name="7" />
          <Edit name="8" />
          <Edit name="9" />
        </Flex>
        <List.Title>What are your most frequent positive emotions?</List.Title>
        <Flex even stack>
          <Edit name="10" Suggestions={Suggestions.PositiveEmotions} />
          <Edit name="11" Suggestions={Suggestions.PositiveEmotions} />
          <Edit name="12" Suggestions={Suggestions.PositiveEmotions} />
        </Flex>
        <List.Title>What do you believe about the world in general?</List.Title>
        <Flex even stack>
          <Edit name="13" />
          <Edit name="14" />
          <Edit name="15" />
        </Flex>
        <List.Title>Identify the positive beliefs that could propel you forward:</List.Title>
        <Flex even stack>
          <Edit name="16" />
          <Edit name="17" />
          <Edit name="18" />
        </Flex>
      </List>
    </Form>
  );
}
